import { Grid } from "@material-ui/core";
import React, { Component } from "react";
import { WithStyles, withStyles, createStyles, Theme } from "@material-ui/core";


const styles = (theme: Theme) => createStyles({
  elementContainer:{
    height: '100vh',
    boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: '#fff',
  },
});

interface Props extends WithStyles<typeof styles> {
  activeSectionKey?: string;
  onChange?: (sectionKey: string) => void;
  padTop?: boolean;
}

interface State {
  currentlyActiveSectionKey: string;
}

class MyPATCollapseSection extends Component<Props, State> {
  state: State = {
    currentlyActiveSectionKey: this.props.activeSectionKey || "",
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.activeSectionKey !== this.props.activeSectionKey) {
      this.setCurrentlyActiveSectionKey(this.props.activeSectionKey || "");
    }
  }

  setCurrentlyActiveSectionKey = (sectionKey: string) => {
    if (this.props.onChange) {
      this.props.onChange(sectionKey);
    } else {
      this.setState({
        currentlyActiveSectionKey: sectionKey,
      });
    }
  };

  onSectionClose = () => {
    this.setCurrentlyActiveSectionKey("");
  };

  render() {
    const {classes, padTop} = this.props;
    const { currentlyActiveSectionKey } = this.state;
    const isAnySectionActive = currentlyActiveSectionKey !== "";
    return (
      <Grid container spacing={24} direction="column" alignItems="flex-end">
        {React.Children.map(this.props.children, (child, i) => {
          if (!React.isValidElement(child) || !child) {
            return <></>;
          }
          // @ts-ignore
          const { sectionKey } = child.props;
          const isActive = sectionKey === currentlyActiveSectionKey;
          if (isAnySectionActive && !isActive) {
            return <></>;
          }
          // @ts-ignore
          const element = React.cloneElement(child, {
            isActive,
            onSectionOpen: this.setCurrentlyActiveSectionKey,
            onClose: this.onSectionClose,
            padTop
          });
          return (
            <Grid item xs="auto" key={i}>
              {element}
            </Grid>
          );
        })}
      </Grid>
    );
  }
}

export default withStyles(styles)(MyPATCollapseSection);

